import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, isFormRecord } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { finalize } from 'rxjs/operators';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:
  `
  <div class="login-card">
    <div class="login-card" *ngIf="showPinSection">
      <!-- AUTHORIIZATION PIN -->
      <p class="pin-text">
        Create your 4-digit PIN.
      </p>
      <div class="pin-warning-text"  *ngIf="pinValidationMessage">
        {{pinValidationMessage}}
      </div>
      <div class="pin-wrapper">
        <input
          #pinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="loginPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onPinChange($event)">

        <div class="pin-wrapper">
          <!-- Hidden input -->
          <input
            #pinInput
            class="hidden-pin-input"
            type="password"
            inputmode="numeric"
            maxlength="4"
            autocomplete="one-time-code"
            [(ngModel)]="loginPin"
            (keydown)="allowOnlyNumbers($event)"
            (ngModelChange)="onPinChange($event)">

            <!-- Click anywhere to focus -->
            <div class="pin-display" (click)="pinInput.focus()">
              <div class="pin-circle"
                  [class.filled]="loginPin.length > 0"
                  [class.active]="loginPin.length === 0">
                {{ loginPin.length > 0 ? '•' : '' }}
              </div>

              <div class="pin-circle"
                  [class.filled]="loginPin.length > 1"
                  [class.active]="loginPin.length === 1">
                {{ loginPin.length > 1 ? '•' : '' }}
              </div>

              <div class="pin-circle"
                  [class.filled]="loginPin.length > 2"
                  [class.active]="loginPin.length === 2">
                {{ loginPin.length > 2 ? '•' : '' }}
              </div>

              <div class="pin-circle"
                  [class.filled]="loginPin.length > 3"
                  [class.active]="loginPin.length === 3">
                {{ loginPin.length > 3 ? '•' : '' }}
              </div>
            </div>
        </div>
      </div>
    </div>

    <div  *ngIf="confirmPinSection">
    <div class="back-btn" (click)="return()">
        ←
      </div>
      <!-- CONFIRM PIN INPUT -->
      <p class="pin-text">
        Confirm your 4-digit PIN.
      </p>
      <div class="pin-warning-text"  *ngIf="confirmPinValidationMessage">
        {{confirmPinValidationMessage}}
      </div>
      <div class="pin-wrapper">
        <input
          #pinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="confirmPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onConfirmPinChange($event)">

        <div class="pin-wrapper">
          <!-- Hidden input -->
        <input
          #confirmPinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="confirmPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onConfirmPinChange($event)">

          <!-- Click anywhere to focus -->
          <div class="pin-display" (click)="confirmPinInput.focus()">
            <div class="pin-circle"
                [class.filled]="confirmPin.length > 0"
                [class.active]="confirmPin.length === 0">
              {{ confirmPin.length > 0 ? '•' : '' }}
            </div>

            <div class="pin-circle"
                [class.filled]="confirmPin.length > 1"
                [class.active]="confirmPin.length === 1">
              {{ confirmPin.length > 1 ? '•' : '' }}
            </div>

            <div class="pin-circle"
                [class.filled]="confirmPin.length > 2"
                [class.active]="confirmPin.length === 2">
              {{ confirmPin.length > 2 ? '•' : '' }}
            </div>

            <div class="pin-circle"
                [class.filled]="confirmPin.length > 3"
                [class.active]="confirmPin.length === 3">
              {{ confirmPin.length > 3 ? '•' : '' }}
            </div>
          </div>
        </div>
      </div>

      <div class="terms-section">
  <label class="terms-checkbox-row">
    <input
      type="checkbox"
      [(ngModel)]="acceptTerms">

    <span class="terms-text">
      By checking this box you confirm that you have read and agree to our
      <a href="" (click)="openTerms($event)">
        Terms of Service
      </a>
      and have read our
      <a href="" (click)="openPrivacy($event)">
        Privacy Policy
      </a>.
    </span>
  </label>
</div>

      <!-- BUTTONS -->
      <div class="btns">
        <button class="set-authorization-btn"
          (click)="saveAuthorizationPin()"
          [disabled]="isLoading ||
              loginPin.length !== 4 ||
              confirmPin.length !== 4 ||
              loginPin !== confirmPin ||
              pinValidationMessage ||
              confirmPinValidationMessage ||
              !acceptTerms">
          <span *ngIf="!isLoading">Save</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>

        <!-- TERMS / PRIVACY MODAL -->
        <div class="modal-overlay" *ngIf="showDocument">
          <div class="document-modal">
            <button class="close-btn" (click)="closeDocument()">
              ✕
            </button>
            <iframe
              [src]="documentUrl"
              class="document-frame">
            </iframe>
          </div>
        </div>
      </div>
    </div>
 
    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
          <p class="pin-text">
              {{ errorMessage }}
          </p>
          <div class="btns">
            <button
              class="primary"
              (click)="closeErrorPopup()">
              Close
            </button>
          </div>
      </div>
    </div>

     <!-- SUCCESS ALERT-->
    <div class="overlay" *ngIf="showSuccessAlert">
      <div class="alert-modal">
        <div class="success-icon">
        ✓
        </div>
        <div class="alert-text">
          {{successAlertMessage}}
        </div>
      </div>
    </div>
  </div>
  `
})
export class SetAuthorizationPinPage implements OnInit{
  userId = '';
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  confirmPinSection = false;
  constructor(private router: Router, private route: ActivatedRoute, private sanitizer: DomSanitizer, private authService: AuthService) {}
  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('userId') ?? '';
    if (!this.userId) {
      this.errorMessage = 'Invalid link';
      this.showErrorPopup = true;
      this.showPinSection = false
      return;
    }
    this.checkSetAuthorizationStatus();
  }
  checkSetAuthorizationStatus() {
    this.authService
    .getSetAuthorizationStatus(this.userId)
    .subscribe({
        next: response => {
          console.log(response);
        },
        error: err => {
          this.showPinSection = false;
          if (err.status === 409) {
            this.router.navigateByUrl(
              '/Login/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          this.errorMessage = err.error?.message ?? 'Unable to load page.';
          this.showErrorPopup = true;
        }
      },
    );
  }
  // =====================================================
  // ERROR
  // =====================================================
  errorMessage = '';
  showErrorPopup = false;
  closeErrorPopup() {
    window.location.href = this.whatsAppUrl;
  }
  // =====================================================
  // AUTHORIZZATION
  // =====================================================
  showPinSection = true;
  loginPin = '';
  confirmPin = '';
  pinValidationMessage = '';
  confirmPinValidationMessage = '';

  return(){
    this.showPinSection = true;
        this.confirmPinSection = false;
        this.loginPin = '';
  }
  onPinChange(value: string): void {
    this.loginPin = value.replace(/\D/g, '').slice(0, 4);
    const validation = this.validatePin(this.loginPin);
    if(validation.isValid){
        this.showPinSection = false;
        this.confirmPinSection = true;
        this.confirmPin = '';
        this.confirmPinValidationMessage = ''; 
        return;
    }
    this.pinValidationMessage = validation.message;
    this.validateConfirmPin(); 
  }
  onConfirmPinChange(value: string): void {
    this.confirmPin = value.replace(/\D/g, '').slice(0, 4);
    this.validateConfirmPin();
  }
  validateConfirmPin() {
    this.confirmPinValidationMessage = '';
    const validation = this.validatePin(this.confirmPin);
    if (!validation.isValid) {
      this.confirmPinValidationMessage = validation.message;
      return;
    }
    if (
      this.confirmPin.length === 4 &&
      this.loginPin !== this.confirmPin
    ) {
      this.confirmPinValidationMessage = 'PINs do not match.';
    }
  }
  validatePin(pin: string): { isValid: boolean; message: string } {
    if (pin.length !== 4) {
      return { isValid: false, message: '' };
    }
    // 1111, 2222, 9999...
    if (/^(\d)\1{3}$/.test(pin)) {
      return {
        isValid: false,
        message: 'PIN cannot contain the same digit four times.'
      };
    }
    // Ascending (1234, 4567)
    let ascending = true;
    for (let i = 1; i < pin.length; i++) {
      if (+pin[i] !== +pin[i - 1] + 1) {
        ascending = false;
        break;
      }
    }
    if (ascending) {
      return {
        isValid: false,
        message: 'PIN cannot be sequential.'
      };
    }
    // Descending (4321, 9876)
    let descending = true;

    for (let i = 1; i < pin.length; i++) {
      if (+pin[i] !== +pin[i - 1] - 1) {
        descending = false;
        break;
      }
    }
    if (descending) {
      return {
        isValid: false,
        message: 'PIN cannot be sequential.'
      };
    }
    // Same forwards and backwards (1221, 3443, 1001)
    if (pin === pin.split('').reverse().join('')) {
      return {
        isValid: false,
        message: 'PIN cannot be the same in reverse.'
      };
    }
    // Repeating pattern (1212, 3434, 9090)
    if (
      pin[0] === pin[2] &&
      pin[1] === pin[3]
    ) {
      return {
        isValid: false,
        message: 'PIN cannot contain repeating patterns.'
      };
    }
    // Two pairs (1122, 7788)
    if (
      pin[0] === pin[1] &&
      pin[2] === pin[3]
    ) {
      return {
        isValid: false,
        message: 'PIN cannot contain repeated pairs.'
      };
    }
    
    return {
      isValid: true,
      message: ''
    };
  }
  successAlertMessage = '';
  showSuccessAlert = false;
  saveAuthorizationPin() {
        this.isLoading = true;
        this.authService
        .postAuthorizationPin(this.userId, this.loginPin, 'set')
        .pipe(
          finalize(() => this.isLoading = false)
        )
        .subscribe({
          next: response => {
             this.successAlertMessage = 'PIN set successfully.';
            this.showSuccessAlert = true;

            setTimeout(() => {
              this.showSuccessAlert = false;

              this.router.navigateByUrl(
                '/login/' + this.userId,
                { replaceUrl: true }
              );
            }, 1500);
          },
          error: err => {
            this.errorMessage = err.error?.message ?? 'Unable to save security questions.';
            this.showErrorPopup = true;
            this.showPinSection = false;
          }
        });
  }
  // =====================================================
  // TERMS & PRIVACY
  // =====================================================
  acceptTerms = false;
  showDocument = false;
  documentUrl!: SafeResourceUrl;

  openTerms(event: Event) {
    event.preventDefault();
    this.documentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.wallety.cash/'
    );
    this.showDocument = true;
  }
  openPrivacy(event: Event) {
    event.preventDefault();
    this.documentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.wallety.cash/'
    );
    this.showDocument = true;
  }
  closeDocument() {
    this.showDocument = false;
  }
  // =====================================================
  // COMMON
  // =====================================================
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}